import { z } from 'zod'

import { DateZod } from '../../common'

export const PiloteUserZod = z.object({
  timestamp: DateZod.nullable().optional(),
  username: z.string(),
  token: z.string().optional(),
})
